import { Controller, useFormContext } from 'react-hook-form';

import SlotSelector from 'src/sections/_home/dashboard/Slots';

const RHFSlotSelector = ({ name, slotsList = [], label = 'Select Slot' }) => {
  const {
    control,
    formState: { errors, disabled },
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field: { onChange, value } }) => (
        <SlotSelector
          slotsList={slotsList}
          label={label}
          value={value}
          onChange={onChange}
          error={!!errors[name]}
          helperText={errors[name]?.message}
          disabled={disabled}
        />
      )}
    />
  );
};

export default RHFSlotSelector;
